<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
          <i class="fas fa-user-alt"></i>
          사용자 목록
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">Main</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">User</a>
          </li>
      </ul>
    </div>
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> 사용자 목록
      </template> -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> 등록 시간</label>
              <b-form inline>
                <date-picker v-model="so.opt.created_at_sd" :lang="custom.lang.ko" :first-day-of-week="1" @keyup.enter="refresh"></date-picker>
                ~
                <date-picker v-model="so.opt.created_at_ed" :lang="custom.lang.ko" :first-day-of-week="1" @keyup.enter="refresh"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_visit"> 최근 방문 시간</label>
              <b-form inline>
                <date-picker v-model="so.opt.last_visit_sd" :lang="custom.lang.ko" :first-day-of-week="1" @keyup.enter="refresh"></date-picker>
                ~
                <date-picker v-model="so.opt.last_visit_ed" :lang="custom.lang.ko" :first-day-of-week="1" @keyup.enter="refresh"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="refresh"> 검색 </b-button>
          <b-button size="sm" variant="secondary" @click="reset"> 리셋 </b-button>
          <b-button size="sm" variant="dark" @click="so.adv = false"> 나가기 </b-button>
        </b-form-group>
      </b-card>

      <b-row>
        <b-col sm="6">
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || '검색'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='username';so.skt='사용자명'">사용자명</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='nickname';so.skt='이름'">이름</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-input v-model="so.sv" @keyup.enter="refresh"></b-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="so.adv = !so.adv; so.sv = ''"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"> 상세검색</i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="is_alive" slot-scope="row">
          <i v-if="row.item.is_alive" class="fa fa-check"></i>
        </template>
        <template slot="username" slot-scope="row">
          <a href="javascript:void(0)" class="a_tag" @click="detail(row.item)">
            <del v-if="row.item.is_del">{{row.item.username}}</del>
            <template v-else>{{row.item.username}}</template>
          </a>
        </template>
        <template slot="permissions" slot-scope="row">{{row.item.permissions}}</template>
        <template slot="group.name" slot-scope="row">{{row.item.group && row.item.group.name}}</template>
        <template slot="last_visit" slot-scope="row">{{row.item.last_visit == '0001-01-01T00:00:00' ? '-' : row.item.last_visit | sdate}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">더보기</b-btn>
        </template>
      </b-table>
      <b-row>
        <b-col class="md-2"></b-col>
        <b-col class="md-8">
          <b-pagination size="sm"  align="center" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
        <b-col class="md-2">
          <div class="pull-right">
            <b-button size="sm" variant="success" @click="$router.push({ name: 'user', params: { id : 'add' } })" class="btn-add"> 등록 </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
